exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fade-enter-active[data-v-514d7854],\n.fade-leave-active[data-v-514d7854] {\n  transition: opacity 0.5s;\n}\n.fade-enter[data-v-514d7854],\n.fade-leave-to[data-v-514d7854] {\n  opacity: 0;\n}\n", ""]);

// exports
